import * as Sentry from "@sentry/react-native";

export const withSentry = app => Sentry.withProfiler(app);
